export let BASE_PATH = 'https://pruneyardcinemas.com';
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
  BASE_PATH = 'https://rts.pruneyardcinemas.com';
}
export const API_BASE_PATH = BASE_PATH + '/api-gateway';
